export default {
  init($element) {

  },
  finalize($element) {

    $element.find('.header-button').on('click', function() {
      const $questionBlock = $(this).parents('.question-block');

      if (!$questionBlock.hasClass('open')) {
        $element.find('.question-block').each(function() {
          $(this).removeClass('open');
          $(this).find('.question-body').stop().slideUp(200);
        });
      }
      
      $questionBlock.toggleClass('open');
      $questionBlock.find('.question-body').stop().slideToggle(200);
    });

  },
}


// WEBPACK FOOTER //
// ./scripts/partials/ssg/frequentlyAskedQuestions.js